import { render, staticRenderFns } from "./BusinessAnalysis.vue?vue&type=template&id=0b057377&scoped=true"
import script from "./BusinessAnalysis.vue?vue&type=script&lang=js"
export * from "./BusinessAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BusinessAnalysis.vue?vue&type=style&index=0&id=0b057377&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b057377",
  null
  
)

export default component.exports